import BasicTable from './BasicTable.vue'

const basicTable={
  install:function (Vue) {
    Vue.component('BasicTable',BasicTable)
  }
};
// 这里的判断很重要
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(basicTable)
}
export default basicTable


// WEBPACK FOOTER //
// ./src/components/BasicTable/index.js